import React from "react"

const Chevron = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M15.3998 9.88001L10.8098 5.29001C10.6224 5.10376 10.369 4.99922 10.1048 4.99922C9.84062 4.99922 9.58716 5.10376 9.3998 5.29001C9.30607 5.38298 9.23168 5.49358 9.18091 5.61544C9.13014 5.7373 9.104 5.868 9.104 6.00001C9.104 6.13203 9.13014 6.26273 9.18091 6.38459C9.23168 6.50645 9.30607 6.61705 9.3998 6.71001L13.9998 11.29C14.0935 11.383 14.1679 11.4936 14.2187 11.6154C14.2695 11.7373 14.2956 11.868 14.2956 12C14.2956 12.132 14.2695 12.2627 14.2187 12.3846C14.1679 12.5065 14.0935 12.6171 13.9998 12.71L9.3998 17.29C9.2115 17.477 9.10518 17.7311 9.10425 17.9965C9.10331 18.2618 9.20783 18.5167 9.3948 18.705C9.58178 18.8933 9.8359 18.9996 10.1013 19.0006C10.3666 19.0015 10.6215 18.897 10.8098 18.71L15.3998 14.12C15.9616 13.5575 16.2772 12.795 16.2772 12C16.2772 11.205 15.9616 10.4425 15.3998 9.88001Z"
        fill="#272D37"
      />
    </svg>
  )
}

export default Chevron
